import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ArrowLeft,
  Briefcase,
  CalendarRange,
  CheckCircle2,
  CircleDollarSign,
  ClipboardList,
  FileText,
  Handshake,
  Users,
} from 'lucide-react';

const funnel = [
  { label: 'Prospectos', count: 18, amount: '$ 12.400.000', tone: 'bg-slate-100 text-slate-700 border-slate-200' },
  { label: 'Diagnostico', count: 9, amount: '$ 7.950.000', tone: 'bg-blue-50 text-blue-700 border-blue-100' },
  { label: 'Propuesta', count: 6, amount: '$ 5.200.000', tone: 'bg-amber-50 text-amber-700 border-amber-100' },
  { label: 'Cierre', count: 3, amount: '$ 2.180.000', tone: 'bg-emerald-50 text-emerald-700 border-emerald-100' },
];

const deals = [
  { client: 'Grupo Delta', service: 'Abono de mantenimiento', stage: 'Propuesta', owner: 'Camila', amount: '$ 850.000', due: '28/03/2026' },
  { client: 'Estudio Roca', service: 'Implementacion inicial', stage: 'Diagnostico', owner: 'Tomás', amount: '$ 1.240.000', due: '25/03/2026' },
  { client: 'Clínica Norte', service: 'Capacitacion y soporte', stage: 'Cierre', owner: 'Lucia', amount: '$ 690.000', due: '22/03/2026' },
  { client: 'Soluciones Vega', service: 'Servicio recurrente mensual', stage: 'Prospectos', owner: 'Micaela', amount: '$ 320.000', due: '31/03/2026' },
];

const agenda = [
  { title: 'Reunion de descubrimiento', detail: 'Grupo Delta · videollamada', date: 'Hoy 16:30' },
  { title: 'Enviar propuesta comercial', detail: 'Estudio Roca · paquete anual', date: 'Mañana 09:00' },
  { title: 'Revisión de contrato', detail: 'Clínica Norte · servicio trimestral', date: '24/03 · 11:15' },
];

export default function VentasProfesional({ onNavigate }) {
  const navigate = useNavigate();

  const goBack = () => {
    if (typeof onNavigate === 'function') onNavigate('ventas-historial');
    else navigate('/sistema/ventas-historial');
  };

  return (
    <div className="w-full min-h-screen bg-[#F8FAFC] font-sans text-slate-700">
      <div className="px-3 py-3 sm:px-4 sm:py-4 lg:px-6 lg:py-5 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={goBack}
              title="Volver al módulo de ventas"
              className="p-2.5 bg-white border border-slate-200 rounded-xl text-slate-400 hover:text-[#51A7FD] shadow-sm transition-all"
            >
              <ArrowLeft size={18} />
            </button>
            <div className="w-10 h-10 bg-[#0B2A36] rounded-2xl flex items-center justify-center shadow-md shrink-0">
              <Briefcase size={18} className="text-[#3FF2AA]" />
            </div>
            <div>
              <h1 className="text-xl md:text-2xl font-black text-slate-800 tracking-tight uppercase">Ventas consultivas</h1>
              <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400 mt-1">
                Gestion comercial para servicios, proyectos y cuentas B2B
              </p>
            </div>
          </div>

          <div className="flex flex-wrap gap-2">
            <button title="Registrar una nueva oportunidad comercial" className="px-4 py-2.5 rounded-xl bg-[#51A7FD] text-white text-[10px] font-black uppercase tracking-widest shadow-sm">
              Nueva oportunidad
            </button>
            <button title="Generar una propuesta o cotización formal" className="px-4 py-2.5 rounded-xl bg-white border border-slate-200 text-slate-700 text-[10px] font-black uppercase tracking-widest shadow-sm">
              Nueva propuesta
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-6">
          <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between">
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">Pipeline activo</p>
              <Handshake size={16} className="text-[#51A7FD]" />
            </div>
            <p className="mt-1.5 text-2xl font-black text-slate-800 tracking-tight">36</p>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Oportunidades</p>
          </div>
          <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between">
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">Ingresos proyectados</p>
              <CircleDollarSign size={16} className="text-emerald-500" />
            </div>
            <p className="mt-1.5 text-2xl font-black text-slate-800 tracking-tight">$ 27.730.000</p>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">En seguimiento</p>
          </div>
          <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between">
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">Propuestas abiertas</p>
              <FileText size={16} className="text-amber-500" />
            </div>
            <p className="mt-1.5 text-2xl font-black text-slate-800 tracking-tight">6</p>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Pendientes de respuesta</p>
          </div>
          <div className="bg-white p-4 rounded-2xl border border-slate-200 shadow-sm">
            <div className="flex items-center justify-between">
              <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">Tareas proximas</p>
              <CalendarRange size={16} className="text-slate-300" />
            </div>
            <p className="mt-1.5 text-2xl font-black text-slate-800 tracking-tight">11</p>
            <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">Agenda comercial</p>
          </div>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-12 gap-4">
          <section className="xl:col-span-8 space-y-4">
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="bg-[#0B2A36] px-5 py-4 border-b border-white/10 flex items-center gap-2">
                <Users size={16} className="text-[#3FF2AA]" />
                <span className="text-[10px] font-black text-white uppercase tracking-widest">Embudo comercial</span>
              </div>
              <div className="p-4 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3">
                {funnel.map((item) => (
                  <div key={item.label} className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-lg border text-[8px] font-black uppercase tracking-widest ${item.tone}`}>
                      {item.label}
                    </span>
                    <p className="mt-3 text-3xl font-black tracking-tight text-slate-800">{item.count}</p>
                    <p className="mt-1 text-[11px] font-black uppercase tracking-tight text-slate-500">{item.amount}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="bg-[#0B2A36] px-5 py-4 border-b border-white/10 flex items-center gap-2">
                <ClipboardList size={16} className="text-[#3FF2AA]" />
                <span className="text-[10px] font-black text-white uppercase tracking-widest">Oportunidades activas</span>
              </div>
              <div className="hidden lg:block overflow-x-auto">
                <table className="w-full text-left min-w-[760px]">
                  <thead>
                    <tr className="bg-[#0B2A36] border-b border-white/10 text-[9px] font-black text-white/70 uppercase tracking-widest">
                      <th className="px-5 py-4">Cliente</th>
                      <th className="px-4 py-4">Servicio</th>
                      <th className="px-4 py-4">Etapa</th>
                      <th className="px-4 py-4">Responsable</th>
                      <th className="px-4 py-4 text-right">Importe</th>
                      <th className="px-5 py-4 text-right">Proxima fecha</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-slate-50">
                    {deals.map((deal) => (
                      <tr key={`${deal.client}-${deal.service}`} className="hover:bg-slate-50 transition-colors">
                        <td className="px-5 py-4 text-[11px] font-black uppercase tracking-tight text-slate-800">{deal.client}</td>
                        <td className="px-4 py-4 text-[10px] font-bold text-slate-600 uppercase">{deal.service}</td>
                        <td className="px-4 py-4"><span className="inline-flex px-2.5 py-1 rounded-lg bg-slate-100 text-slate-600 text-[8px] font-black uppercase tracking-widest">{deal.stage}</span></td>
                        <td className="px-4 py-4 text-[10px] font-bold text-slate-500 uppercase">{deal.owner}</td>
                        <td className="px-4 py-4 text-right text-[11px] font-black text-slate-800">{deal.amount}</td>
                        <td className="px-5 py-4 text-right text-[10px] font-bold text-slate-500 uppercase">{deal.due}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="lg:hidden p-3 space-y-3">
                {deals.map((deal) => (
                  <div key={`mobile-${deal.client}-${deal.service}`} className="rounded-2xl border border-slate-200 p-4 bg-white">
                    <div className="flex items-start justify-between gap-3">
                      <div>
                        <p className="text-[11px] font-black uppercase tracking-tight text-slate-800">{deal.client}</p>
                        <p className="mt-1 text-[10px] font-bold uppercase tracking-tight text-slate-500">{deal.service}</p>
                      </div>
                      <span className="inline-flex px-2.5 py-1 rounded-lg bg-slate-100 text-slate-600 text-[8px] font-black uppercase tracking-widest">{deal.stage}</span>
                    </div>
                    <div className="mt-3 grid grid-cols-2 gap-3">
                      <div>
                        <p className="text-[8px] font-black uppercase tracking-widest text-slate-400">Responsable</p>
                        <p className="mt-1 text-[10px] font-black uppercase text-slate-700">{deal.owner}</p>
                      </div>
                      <div className="text-right">
                        <p className="text-[8px] font-black uppercase tracking-widest text-slate-400">Importe</p>
                        <p className="mt-1 text-[10px] font-black text-slate-800">{deal.amount}</p>
                      </div>
                    </div>
                    <p className="mt-3 text-[9px] font-black uppercase tracking-widest text-slate-400">Siguiente accion {deal.due}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <aside className="xl:col-span-4 space-y-4">
            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="bg-[#0B2A36] px-5 py-4 border-b border-white/10 flex items-center gap-2">
                <CalendarRange size={16} className="text-[#3FF2AA]" />
                <span className="text-[10px] font-black text-white uppercase tracking-widest">Agenda proxima</span>
              </div>
              <div className="p-4 space-y-3">
                {agenda.map((item) => (
                  <div key={item.title} className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                    <p className="text-[11px] font-black uppercase tracking-tight text-slate-800">{item.title}</p>
                    <p className="mt-1 text-[10px] font-bold text-slate-500 uppercase tracking-tight">{item.detail}</p>
                    <p className="mt-3 text-[8px] font-black uppercase tracking-widest text-slate-400">{item.date}</p>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">
              <div className="bg-[#0B2A36] px-5 py-4 border-b border-white/10 flex items-center gap-2">
                <CheckCircle2 size={16} className="text-[#3FF2AA]" />
                <span className="text-[10px] font-black text-white uppercase tracking-widest">Uso recomendado</span>
              </div>
              <div className="p-4 space-y-3">
                <div className="rounded-2xl border border-slate-100 bg-slate-50 p-4">
                  <p className="text-[9px] font-black uppercase tracking-widest text-slate-400">Ideal para</p>
                  <p className="mt-2 text-[11px] font-bold text-slate-600 leading-relaxed">
                    Estudios, agencias, consultoras, instaladores, mantenimiento, implementaciones y ventas B2B con seguimiento.
                  </p>
                </div>
                <div className="rounded-2xl border border-emerald-100 bg-emerald-50 p-4">
                  <p className="text-[9px] font-black uppercase tracking-widest text-emerald-700">Siguiente etapa</p>
                  <p className="mt-2 text-[11px] font-bold text-emerald-800 leading-relaxed">
                    Podemos conectarlo a prospectos, clientes, presupuestos y facturacion para que deje de ser solo visual y pase a flujo operativo real.
                  </p>
                </div>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}
